import React, { useEffect, useMemo, useState } from 'react'
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
import moment from 'moment';
import useStateRef from 'react-usestateref';
import { Button } from 'react-bootstrap';

const NonLivingCalenderV1 = (props) => {
    console.log("NonLivingCalenderV1", props?.currentData);
    const [disabled, setDisabled, disabledRef] = useStateRef(false);
    const [selectedAlternateDate, setSelectedAlternateDate, selectedAlternateDateRef] = useStateRef(props?.currentData?.currentDate ? true : false);
    const [showDate, setShowDate, showDateRef] = useStateRef(new Date(moment(props?.currentData?.currentDate)));
    const [selectDate, setSelectDate, selectDateRef] = useStateRef(new Date(moment(props?.currentData?.currentDate)));



    const weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    const validShowDate = (showDateRef.current instanceof Date && !isNaN(showDateRef.current)) ? showDateRef.current : new Date();
    const validSelectedDate = (selectDateRef.current instanceof Date && !isNaN(selectDateRef.current)) ? selectDateRef.current : null;

    const firstDayThisMonth = new Date(validShowDate.getFullYear(), validShowDate.getMonth(), 1);
    const dayOfWeek = firstDayThisMonth.getDay();
    const firstDayNextMonth = new Date(validShowDate.getFullYear(), validShowDate.getMonth() + 1, 1);
    const lastDayThisMonth = new Date(firstDayNextMonth - 1);
    const lastDayOfWeek = lastDayThisMonth.getDay();
    const currentMoment = moment();
    const isCurrentMonth = validShowDate.getFullYear() === currentMoment.year() && validShowDate.getMonth() === currentMoment.month();

    const [displayDateNonLiving, setDisplayDateNonLiving, displayDateNonLivingRef] = useStateRef(props?.currentData?.currentDate ? ` ${moment(props?.currentData?.currentDate).format('MMMM DD, YYYY')}` : 'Select a date')
    let formattedDateCurrent = moment(props?.currentData?.currentDate).format('YYYY-MM-DD HH:mm:ss.SSS');


    const month = useMemo(() => {
        const days = [];
        for (let d = firstDayThisMonth; d < firstDayNextMonth; d.setDate(d.getDate() + 1)) {
            days.push(new Date(d));
        }
        return days;
    }, [validShowDate]);

    useEffect(() => {
        setShowDate(new Date(moment(props?.currentData?.currentDate)))
        setSelectDate(new Date(moment(props?.currentData?.currentDate)))
        setDisplayDateNonLiving(props?.currentData?.currentDate ? ` ${moment(props?.currentData?.currentDate).format('MMMM DD, YYYY')}` : 'Select a date')
        formattedDateCurrent = moment(props?.currentData?.currentDate).format('YYYY-MM-DD HH:mm:ss.SSS');

    }, [props.currentData])
    const parseDates = (dateString) => {
        if (!dateString) return [];
        return dateString.split(' ').map(date => {
            const parsedDate = moment(date, 'MM/DD/YYYY', true);
            return parsedDate.isValid() ? parsedDate.toDate() : null;
        }).filter(date => date !== null);
    };
    const isDateInList = (date, list) => {
        return list.some(d => d.getTime() === date.getTime());
    };
    // For living item alternateDates1 & alternateDates2 are enable, For livingSpecial item alternateDates1 only enable & specialAlternateDates2 are disable

    let alternateDates1 = parseDates(props?.currentData?.dates?.alternateDates1 ?? '');
    let alternateDates2 = parseDates(props?.currentData?.dates?.alternateDates2 ?? '');
    const onChange = (date) => {
        console.log("onChange fired");
        // setShowDate(date)
        setSelectDate(date)
        setDisplayDateNonLiving(moment(date).format('MMMM DD, YYYY'));
    }



    async function handleNonLivingCalendar(event) {
        console.log("handleNonLivingCalendar fired");
        event.preventDefault();
        setDisabled(true)
        var actionUrl = "api/rest/cb/checkout/non-living-calendar";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            specialInstruction: "",
            groupName: "KEY_NON_LIVE_ITEMS",
            currentDate: formattedDateCurrent,
            currentShipMethod: "Standard Ground",
            selectedDate: moment(displayDateNonLivingRef.current).format('MM/DD/YYYY'),
            modifiedShippingMethod: "Standard Ground"
        }))

        if (res.result == "success") {
            var livingModalClose = document.getElementById("non-living-modal-success")
            setDisabled(false)
            livingModalClose.click();
            props.handleOrderDetails()
        }
        else {
            setDisabled(false)
            console.log("errorList-----", res)
        }

    }



    return (
        <div> <div className="modal fade c-modal p-0 m-0" id="nonLiving-calendar-modalV1" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                <div className="modal-content">
                    <button type="button" id="non-living-modal-success" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                    <div className="modal-body">
                        <div className='row'>
                            <div className='col-12'>
                                <div className="form-group row px-md-5 py-md-5">
                                    <div className="col-md-7">
                                        <div className="mt-0">
                                            <h1 className="c-account-heading mb-3">
                                                Change Arrival date for all<br />in-stock, non-perishable items
                                            </h1>
                                        </div>
                                        <div className="fst-italic mt-4">
                                            <span>Selected Date:</span>
                                            <span id="dateDisplay">{displayDateNonLivingRef.current}</span>
                                        </div>
                                        <div className="col-md-6 p-0 mt-2 mb-5 ">
                                            <button className="btn btn-primary btn-carolina no-padding-lr w-100" disabled={disabledRef.current == true ? true : ""} onClick={(event) => handleNonLivingCalendar(event)}>SAVE DATE</button>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-5 cb-calendar-modal">
                                        <div className="calendar">
                                            <div className="d-flex justify-content-between cb-month-row">
                                                <Button className='cb-month-previous'
                                                    onClick={() => setShowDate(new Date(validShowDate.getFullYear(), validShowDate.getMonth() - 1, 1))}
                                                    disabled={isCurrentMonth}>
                                                    <span>&lt;</span>
                                                </Button>
                                                <div className='cb-month-cell'>{validShowDate.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}</div>
                                                <Button className='cb-month-next' onClick={() => setShowDate(new Date(validShowDate.getFullYear(), validShowDate.getMonth() + 1, 1))}>
                                                    <span>&gt;</span>
                                                </Button>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                {weekDays.map((weekDay, index) => (
                                                    <div key={index} className="day cb-weekday">
                                                        <small>{weekDay}</small>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="d-flex flex-wrap list-days">
                                                {Array.from({ length: dayOfWeek }).map((_, index) => (
                                                    <div key={index} className="day cell_day empty_cell_start" style={{ flex: '0 0 14.28%' }}></div>
                                                ))}
                                                {month.map((day) => {
                                                    const isAlternateDate1 = isDateInList(day, alternateDates1);

                                                    const highlightSelectedDate =
                                                        validSelectedDate &&
                                                        validSelectedDate.getDate() === day.getDate() &&
                                                        validSelectedDate.getMonth() === day.getMonth() &&
                                                        validSelectedDate.getFullYear() === day.getFullYear();
                                                    const variant = isAlternateDate1 ? 'onchange-dates' : 'disabled-dates';
                                                    const disabled = !isAlternateDate1

                                                    return (
                                                        <div key={day} className="day cell_day cell_of_days">
                                                            <Button
                                                                variant={highlightSelectedDate ? 'highlight-selected-date' : variant}
                                                                onClick={() => onChange(day)}
                                                                className="w-100"
                                                                disabled={disabled}
                                                            >
                                                                {day.getDate()}
                                                            </Button>
                                                        </div>
                                                    );
                                                })}
                                                {Array.from({ length: 6 - lastDayOfWeek }).map((_, index) => (
                                                    <div key={index} className="day cell_day empty_cell_end" style={{ flex: '0 0 14.28%' }}></div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default NonLivingCalenderV1